var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copy-field",on:{"click":_vm.interact,"hover":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',{staticClass:"overlay",class:{
      show: this.showOverlay,
    }},[_c('span',{staticClass:"text"},[_c('Locale',{attrs:{"path":"events.copied"}})],1)]),_c('input',{ref:"input",attrs:{"readonly":""},domProps:{"value":_vm.value}}),_c('CopyIcon',{attrs:{"size":_vm.IconSize.Tiny}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }